let valid = false;

if (localStorage.getItem("admin")) {
  valid = true;
}

export default valid;
